import FileInput from './component';
import { FileInputProps } from './types';

export type { FileInputProps };
export default FileInput;
